/**
 * カレント表示 IntersectionObserver API 
 */

// 今回の交差を監視する要素
const sections = document.querySelectorAll(".js-section");

const indexOptions = {
  root: null, // 今回はビューポートをルート要素とする
  rootMargin: "-50% 0px", // ビューポートの中心を判定基準にする
  threshold: 0, // 閾値は0
};
const indexObserver = new IntersectionObserver(doWhenIntersect, indexOptions);
// それぞれのsectionを監視する
sections.forEach((section) => {
  indexObserver.observe(section);
});

/**
 * 交差したときに呼び出す関数
 * @param entries
 */
function doWhenIntersect(entries) {
  // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      activateIndex(entry.target);
    }
  });
}

/**
 * 目次の色を変える関数
 * @param element
 */
function activateIndex(element) {
  // すでにアクティブになっている目次を選択
  const currentActiveLinks = document.querySelectorAll(".is-current");
  // すでにアクティブになっているものが0個の時（=null）以外は、is-currentクラスを除去
  if (currentActiveLinks.length > 0) {
    currentActiveLinks.forEach((link) => {
      link.classList.remove("is-current");
    });
  }
  // 引数で渡されたDOMが飛び先のaタグを選択し、is-currentクラスを付与
  const newActiveLinks = document.querySelectorAll(`a[href='#${element.id}']`);
  newActiveLinks.forEach((link) => {
    link.classList.add("is-current");
  });
}
